import ModalScrollPanel from './ModalScrollPanel';
export default ModalScrollPanel;